import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'
import { title } from './Consts'

export function getReceiveEmail(t: TFunction): OnboardingStep {
  return {
    id: 'receive_email',
    type: 'custom',
    wordings: {
      title: t(`receive-email.${title}`)
    }
  }
}
